module.exports = __webpack_public_path__ + "media/fonts/lg-0add5958.woff";